import { CoreContext } from 'context/CoreContext'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { CompanyButtonContainer, ModalContainer, TextLabel } from './styled'
import Wrapper from '../Wrapper';
import Button from 'components/Form/Button';
import FormCore from '../../Form/Core'
import { industryOptions, tableOptions } from 'utils/options';
import useForm from 'hooks/useForm';
import useI18n from 'hooks/useI18n';
import { Create, Read } from 'services/core';
import { exposeStrapiError } from 'utils';
import { toast } from 'react-toastify';

export default function ModalUpload() {

  const { modal, setModal } = useContext(CoreContext)
  const formRef = useRef()
  const [register, setRegister] = useState(null)
  const [loading, setLoading] = useState(false)
  const [options, setOptions] = useState(null)
  const { t } = useI18n()

  const close = () => {
    setModal(null)
  }
  function namesToString(list = []) {
    return list
      .map(item => item?.title || item?.name)
      .filter(Boolean)
      .join(', ');
  }
  const handleSave = () => {
    if (typeof modal?.reload === 'function') { modal?.reload(); }
    close()
  }

  const formItems = useMemo(() => [
    {
      ref: 'title',
      placeholder: t('title'),
      half: true,
      require: true,
    },
    {
      ref: 'table',
      placeholder: t('table'),
      options: tableOptions,
      half: true,
      require: true,
    },
    {
      ref: 'tags',
      placeholder: t('tags'),
      options: options?.tagOptions,
      half: true,
      require: true,
      multi: true
    },
    {
      ref: 'tag_types',
      placeholder: t('tag-types'),
      options: options?.tagTypeOptions,
      half: true,
      multi: true
    },
    {
      ref: 'categories',
      placeholder: t('categories'),
      options: options?.categoryOptions,
      half: true,
      multi: true
    },
    {
      ref: 'sub_categories',
      placeholder: t('sub-categories'),
      options: options?.subCategoryOptions,
      half: true,
      multi: true
    },
    {
      custom: <TextLabel>
        Please share the context of the file you’re sending? <br />
        Including:
        What it is (type/purpose of the file)<br />
        Who it’s for (team, department, or target audience)<br />
        Where it should be available (country/region/global)<br />
        Any additional details that help us understand how to use it or why it matters<br />
        Example: This is a new business calculator for sales teams in Europe. It helps with currency
        conversion and faster quoting.<br />
        • Ideal file name that makes it easy to find using the search bar.
      </TextLabel>,
      full: true
    },
    {
      ref: 'context',
      placeholder: t('context'),
      full: true,
      type: 'textarea',
      textArea: true
    },
    {
      ref: 'document',
      placeholder: t('document'),
      type: 'upload',
      // required: true,
      accept: 'application/pdf,image/*',
      half: true
    },
    {
      ref: 'image',
      placeholder: t('image'),
      type: 'upload',
      // required: true,
      half: true,

    }
  ], [t, options])

  const init = async () => {
    const [tagsRes, tagTypesRes, categoriesRes, subCategoriesRes] = await Promise.all([
      Read('tags'),
      Read('tag-types'),
      Read('categories'),
      Read('sub-categories'),
    ])

    if (exposeStrapiError(tagsRes)) return
    if (exposeStrapiError(tagTypesRes)) return
    if (exposeStrapiError(categoriesRes)) return
    if (exposeStrapiError(subCategoriesRes)) return

    const toOption = (m) => ({
      id: m?.id,
      title: m?.title || m?.name,
    })

    setOptions({
      tagOptions: (tagsRes?.data || []).map(toOption),
      tagTypeOptions: (tagTypesRes?.data || []).map(toOption),
      categoryOptions: (categoriesRes?.data || []).map(toOption),
      subCategoryOptions: (subCategoriesRes?.data || []).map(toOption),
    })
  }

  useEffect(() => { init() }, [])

  const doSave = async () => {
    const form = formRef?.current?.getForm()
    if (!form) return

    if (!form?.table) {
      toast.error(t('table') + ' is required')
      return
    }

    setLoading(true)

    const body = {
      title: form?.title,
      tags: form?.tags || [],
      categories: form?.categories,
      tag_types: form?.tag_types,
      sub_categories: form?.sub_categories,
      approved: false
    }

    if (form?.document?.id) body.document = form.document.id
    if (form?.image?.id) body.image = form.image.id

    const result = await Create(`${form.table}?populate=*`, { data: body })

    const emailData = {
      "toEmail": "steve2@uorak.com",
      "requestId": result?.data?.id,
      "content": {
        "contentTitle": result?.data?.title,
        "contentType": form?.table,
        "tagType": namesToString(result?.data?.tag_types),
        "categories": namesToString(result?.data?.categories),
        "subcategories": namesToString(result?.data?.sub_categories),
        "tags": namesToString(result?.data?.tags),
      }
    }
    if (result && !exposeStrapiError(result)) {
      await Create('send-email/upload', { data: emailData })
      toast.success(t('upload_success'))
    }
    setLoading(false)
    setModal({})
  }

  return (
    <>
      <Wrapper title={t('upload_title')} text={t('describe_as_upload')}>
        <ModalContainer>
          <FormCore ref={formRef} register={register} formItems={formItems} />
        </ModalContainer>
        <TextLabel>
          What happens after sending this material?
          The MagVenture Universe team will receive your approval request. If approved, you will
          receive an email notification confirming the upload. If not, a member of our team will
          contact you to align on any necessary adjustments before the material/content is
          uploaded, always in compliance with our RA regulations.
        </TextLabel>
        <CompanyButtonContainer>
          <Button onClick={close} width={'120px'} outline small nospace>{t('cancel')}</Button>
          <Button color="blue" loading={loading} onClick={doSave} width={'120px'} small between nospace>{t('send')}</Button>
        </CompanyButtonContainer>
      </Wrapper>
    </>
  )
}
